import { apiAxiosCMS } from 'services/api';
import { ItemFromElementMenuProps } from 'types/ElementMenuProps';

interface RespProps {
	isSuccess: boolean;
	data: ItemFromElementMenuProps[];
}

export async function getElementsId(slug: string, handleNotify: any) {
	const resp: RespProps = { isSuccess: false, data: [] };
	await apiAxiosCMS
		.get(
			`menu-items?location_slug=${slug}&language_slug=en&levelTree=3&withFileRight=true&withFileLeft=true&withFileBanner=true`
		)
		.then((res) => {
			resp.data = res.data;
			resp.isSuccess = true;
		})
		.catch((error) => {
			resp.data = [];
			resp.isSuccess = false;
			handleNotify(error?.message || 'Erro ao buscar os itens', 'error');
		});

	return resp;
}
